import el from "@cypherpotato/el";
import { api } from "../api";
import { formatCurrency } from "../ui/format";
import { NumberInput } from "./form";
import { Section } from "./layout";
import { Table, TableBody, TableCell, TableRow } from "./table";
import { MutedText } from "./text";

export function CreditPickerControl() {

    const selectedAmount = el.state.create(10);
    const fee = el.state.create({ providerFee: 0, aivaxFee: 0, amount: 0, total: 0 });

    function calcFinalValue() {
        api.getJson("/api/v1/payments?" + new URLSearchParams({ amount: selectedAmount.value }).toString()).then(res => {
            fee.value = res.data;
        })
    }

    calcFinalValue();

    return el(".credit-picker",
        Section(
            NumberInput({
                value: selectedAmount.value,
                min: 3,
                max: 30_000,
                step: 5,
                onChange(value) {
                    selectedAmount.value = value;
                    calcFinalValue();
                }
            })
        ),
        el.state.listening([fee], () =>
            Section(
                Table(
                    TableBody(
                        TableRow(
                            TableCell(MutedText("Processor fee")),
                            TableCell(fee.value?.providerFee && formatCurrency(fee.value.providerFee) || "-", {
                                style: { textAlign: "right" }
                            })
                        ),
                        TableRow(
                            TableCell(MutedText("Service fee")),
                            TableCell(fee.value?.aivaxFee && formatCurrency(fee.value.aivaxFee) || "-", {
                                style: { textAlign: "right" }
                            })
                        ),
                        TableRow(
                            TableCell(MutedText("Total")),
                            TableCell(fee.value?.total && formatCurrency(fee.value.total) || "-", {
                                style: { fontWeight: "bold", textAlign: "right" }
                            })
                        )
                    )
                )
            )
        ),
        {
            $properties: {
                value: {
                    get() {
                        return {
                            amount: selectedAmount.value
                        };
                    },
                    // set(value) {
                    //     selectedAmount.value = value;
                    // }
                }
            }
        }
    )
}